import { CRUDSelectors } from 'redux/crudCreator';
import { MODEL_NAME } from './actions';

export const companyBrandsSelectors = new CRUDSelectors(MODEL_NAME);
